import { BaseModel } from '@tcc-mono/shared/data-access';
import { Animal } from "./animal.model";

export class Ride extends BaseModel {
  id: number;
  animal_count?: number;
  closed_at?: string;
  created_at?: string;
  hub_id?: number;
  hub_name?: string;
  destination_name?: string;
  destination_ubn?: number;
  license_plate?: string;
  relation_address?: string;
  relation_city?: string;
  relation_contact?: string;
  relation_id?: number;
  relation_name?: string;
  relation_phone?: string;
  relation_zip?: string;
  remarks?: string;
  scanning_done?: string;
  number?: string;
  animals?: Animal[];
  kvs_animal_error_count: number;
  kvs_closed_at: string;
  kvs_force_closed_at?: string;
  kvs_force_closed_by_user_id?: number;
  kvs_ride_error_code: string;
  kvs_ride_error_message: string;
  kvs_ride_id: PropertyKey;
  kvs_ride_number: string;
  origin: 'kvs' | 'trader'
  kvs_trader_name?: string | null;
}
